import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useAxios } from '../../../hooks/useAxios';
import Skeleton from "../../../components/Skeleton/Skeleton";
import Modal2 from "../../../components/modalsus2026/ModalSus";
import './blogs.css';

const Blogs = () => {

    const [t, i18n] = useTranslation("home");
    const [g] = useTranslation("global");

    const { data, isloading } = useAxios(
        `https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/blogs/n?offset=0&next=4&lang=${i18n.language}`
    );

    const liga_lang = '/' + i18n.language + "/Mi-blog";
    const [blogs, setBlogs] = useState(null);

    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    const getReadingTime = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {

            const partes = txtresumen.split("||");

            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim() + " MIN";
            }
        }

        const i = Math.floor(Math.random() * 5) + 1;
        return i + " MIN";
    };

    const numero = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            const partes = txtresumen.split("||");
            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim();
            }
        }
        return Math.floor(Math.random() * 4) + 1;
    };

    const resumensplit = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            const partes = txtresumen.split("||");
            if (partes.length > 1 && partes[0].trim() !== "") {
                return partes[0].trim();
            }
        }
        return txtresumen;
    };

    const cleanResumen = (txt) => {
        if (!txt) return "";
        return txt.split("||")[0];
    };

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Home',
            event_label: label,
            value: 1
        });
    };

    const truncateText = (text, limit) => {
        if (!text) return "";

        const cleanText = cleanResumen(text);

        if (cleanText.length <= limit) {
            return cleanText;
        }

        return cleanText.slice(0, limit).trim() + "...";
    };

    const getResponsiveImage = (url) => {
        if (window.innerWidth > 1200) {
            // Inserta "_min" antes de la extensión
            return url.replace(/(\.[a-zA-Z0-9]+)$/, '_min$1');
        }

        return url;
    };

    const getFocusClass = (url) => {

        if (!url) return '';

        const lowerUrl = url.toLowerCase();

        if (lowerUrl.includes('_der.')) {
            return 'foco-derecha';
        }

        if (lowerUrl.includes('_izq.')) {
            return 'foco-izquierda';
        }

        if (lowerUrl.includes('_cen.')) {
            return 'foco-centro';
        }

        return '';
    };

    useEffect(() => {
        if (data) {
            setBlogs(data);
        }
    }, [data]);

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('es-MX');
    };

    if (isloading || blogs === null) {
        return (
            <section className="home-blog home-blog-Skeleton">

                <div className="home-blog__featured">

                    <div className="home-blog__featured-story">
                        <Skeleton
                            width="120px"
                            height="20px"
                            style={{ marginBottom: 20 }}
                        />

                        <Skeleton
                            width="80%"
                            height="52px"
                            style={{ marginBottom: 20 }}
                        />

                        <Skeleton
                            width="100%"
                            height="20px"
                            style={{ marginBottom: 12 }}
                        />

                        <Skeleton
                            width="90%"
                            height="20px"
                            style={{ marginBottom: 20 }}
                        />

                        <Skeleton
                            width="220px"
                            height="18px"
                        />
                    </div>

                    <div className="home-blog__featured-image-wrap">
                        <Skeleton
                            width="100%"
                            height="420px"
                            borderRadius="20px"
                        />
                    </div>

                </div>

                <aside className="home-blog__sidebar">

                    {[1, 2, 3].map((i) => (
                        <div key={i} className="home-blog__sidebar-story">

                            <Skeleton
                                width="100px"
                                height="18px"
                                style={{ marginBottom: 16 }}
                            />

                            <Skeleton
                                width="100%"
                                height="32px"
                                style={{ marginBottom: 16 }}
                            />

                            {i !== 3 && (
                                <>
                                    <Skeleton
                                        width="100%"
                                        height="18px"
                                        style={{ marginBottom: 10 }}
                                    />

                                    <Skeleton
                                        width="85%"
                                        height="18px"
                                        style={{ marginBottom: 16 }}
                                    />
                                </>
                            )}

                            <Skeleton
                                width="180px"
                                height="16px"
                            />

                        </div>
                    ))}

                </aside>

            </section>
        );
    }

    return (
        <>
            <div>
                <section className="home-blog">

                    <div className="home-blog__featured">
                        <a onClick={() => trackAnalyticsClick('Home - Blogs: '+blogs[0].titulo)} href={'/blog/' + blogs[0].tag} className="home-blog__featured-story" tabIndex="0">
                            <p className="home-blog__tag home-blog__tag_pri">
                                <a href={"/" + i18n.language + "/Mi-blog?categoria=" + blogs[0].categorias[0].tagCategory.toLowerCase()}>
                                    {blogs[0].categorias[0].nombre}
                                </a>
                            </p>
                            <h1 className="home-blog__featured-title">{blogs[0].titulo}</h1>
                            <p className="home-blog__featured-summary">
                                {resumensplit(blogs[0].resumen)}
                            </p>
                            <p className="home-blog__meta">
                                {formatDate(blogs[0].fecha)} · {numero(blogs[0].resumen)} {t('minutes.minutes-lecture')}
                            </p>
                        </a>

                        <div className="home-blog__featured-image-wrap" tabIndex="0">
                            <a onClick={() => trackAnalyticsClick('Home - Blogs: '+blogs[0].titulo)} href={'/blog/' + blogs[0].tag}>
                                <img
                                    loading="eager"
                                    className={`home-blog__featured-image ${getFocusClass(blogs[0].urlImagen)}`}
                                    src={getResponsiveImage(blogs[0].urlImagen)}
                                    alt={blogs[0].titulo}
                                />
                            </a>
                        </div>
                    </div>

                    <aside className="home-blog__sidebar">

                        {[1, 2, 3].map((i) => (
                            <a onClick={() => trackAnalyticsClick('Home - Blogs: '+blogs[i].titulo)} href={'/blog/' + blogs[i].tag} key={i} className="home-blog__sidebar-story" tabIndex="0">
                                <p className="home-blog__tag">
                                    <a href={"/" + i18n.language + "/Mi-blog?categoria=" + blogs[i].categorias[0].tagCategory.toLowerCase()}>
                                        {blogs[i].categorias[0].nombre}
                                    </a>
                                </p>
                                <h2 className="home-blog__sidebar-title">{blogs[i].titulo}</h2>

                                {i !== 3 && (
                                    <p className="home-blog__sidebar-summary">
                                        {resumensplit(blogs[i].resumen)}
                                    </p>
                                )}

                                <p className="home-blog__meta">
                                    {formatDate(blogs[i].fecha)} · {numero(blogs[i].resumen)} {t('minutes.minutes-lecture')}
                                </p>
                            </a>
                        ))}

                    </aside>

                    <div arialabel="Más historias" className="_nghost-ng-c1244515913 blog-feature-split__list_tablet">
                        <section class="blog-text-cards-row blog-text-cards-row--second"
                            aria-label="Más historias">
                            <div class="blog-text-cards-row__inner">
                                {[1, 2, 3].map((i) => (

                                    <article class="blog-text-cards-row__card" tabindex="0">
                                        <a onClick={() => trackAnalyticsClick('Home - Blogs: '+blogs[i].titulo)} href={'/blog/' + blogs[i].tag}>
                                            <p class="blog-text-cards-row__tag">{blogs[i].categorias?.[0]?.nombre?.toUpperCase()}</p>
                                            <h3 >{blogs[i].titulo}</h3>
                                            <p class="blog-text-cards-row__excerpt">{truncateText(blogs[i].resumen, 120)}</p>
                                            <p class="blog-text-cards-row__meta">{formatDate(blogs[i].fecha)} · {getReadingTime(blogs[i].resumen)}</p>
                                        </a></article>

                                ))}
                            </div>
                        </section>
                    </div>

                    <a onClick={() => trackAnalyticsClick('Home - Todas las entradas')} className="home-blog__mobile-link" href={liga_lang}>
                        {g('general.all-entries')}
                    </a>

                </section>


            </div>
            <div class="_ngcontent-ng-c3767649554 _nghost-ng-c2625480866">
                <section aria-label="Suscripcion movil" class="home-mobile-subscribe">
                    <p class="home-mobile-subscribe__title">{t("2026.novedades")}</p>
                    <button type="button" class="home-mobile-subscribe__button" onClick={() => {openModal2();trackAnalyticsClick('Home - Suscribete')}} >{g('general.suscribirsebtn2')}</button>
                </section>
            </div>
            <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
        </>
    );
};

export default Blogs;